import { openBlock as d, createElementBlock as m, renderSlot as C, defineComponent as L, computed as E, normalizeClass as h, useAttrs as A, createElementVNode as f, ref as $, onMounted as H, watch as B, nextTick as S, onBeforeUnmount as V, createCommentVNode as D, createBlock as G, Teleport as Q, normalizeStyle as j, onUnmounted as F, unref as M, useId as R, createTextVNode as K, toDisplayString as U, resolveComponent as J, withCtx as W, Fragment as X, renderList as Y } from "vue";
const Z = {
  name: "TContainer"
}, P = (o, c) => {
  const e = o.__vccOpts || o;
  for (const [s, t] of c)
    e[s] = t;
  return e;
}, ee = { class: "t-container" };
function te(o, c, e, s, t, n) {
  return d(), m("div", ee, [
    C(o.$slots, "default")
  ]);
}
const oe = /* @__PURE__ */ P(Z, [["render", te]]), ne = /* @__PURE__ */ L({
  __name: "TText",
  props: {
    center: { type: [Boolean, String] }
  },
  emits: ["click"],
  setup(o, { emit: c }) {
    const e = o, s = c, t = E(() => {
      const n = [];
      return Object.keys(e).forEach((a) => {
        e[a] && n.push("t-text--" + a);
      }), n;
    });
    return (n, a) => (d(), m("div", {
      onClick: a[0] || (a[0] = (r) => s("click", r)),
      class: h(["t-text", t.value])
    }, [
      C(n.$slots, "default")
    ], 2));
  }
}), se = { class: "t-header--bg" }, ae = { class: "t-header--top-offset" }, le = /* @__PURE__ */ L({
  __name: "THeader",
  setup(o) {
    const c = A(), e = E(() => {
      const s = [];
      return Object.keys(c).forEach((t) => {
        c[t] !== void 0 && s.push("t-header--" + t);
      }), s;
    });
    return (s, t) => (d(), m("header", {
      class: h(["t-header", e.value])
    }, [
      f("div", se, [
        C(s.$slots, "default")
      ]),
      f("div", ae, [
        C(s.$slots, "content")
      ])
    ], 2));
  }
}), ie = /* @__PURE__ */ L({
  __name: "TCard",
  emits: ["click"],
  setup(o, { emit: c }) {
    const e = A(), s = c, t = E(() => {
      const n = [];
      return Object.keys(e).forEach((a) => {
        e[a] !== void 0 && n.push("t-card--" + a);
      }), n;
    });
    return (n, a) => (d(), m("div", {
      onClick: a[0] || (a[0] = (r) => s("click", r)),
      class: h(["t-card", t.value])
    }, [
      C(n.$slots, "default")
    ], 2));
  }
}), ce = /* @__PURE__ */ L({
  __name: "TContent",
  setup(o) {
    const c = A(), e = E(() => {
      const s = [];
      return Object.keys(c).forEach((t) => {
        c[t] !== void 0 && s.push("t-content--" + t);
      }), s;
    });
    return (s, t) => (d(), m("div", {
      class: h(["t-content", e.value])
    }, [
      C(s.$slots, "default")
    ], 2));
  }
}), re = ["innerHTML"], ue = ["innerHTML"], de = /* @__PURE__ */ L({
  __name: "TTooltip",
  props: {
    show: Boolean,
    disabled: Boolean,
    text: String,
    detached: Boolean
  },
  emits: ["off", "body-off"],
  setup(o, { emit: c }) {
    const e = o, s = $(null), t = $(null), n = $(null), a = $(null), r = $(null), u = $("t-bc"), x = $(null), k = $(!1);
    let w = -1;
    const b = A(), y = c;
    H(() => {
      i();
    }), B(
      () => e.detached,
      (g) => {
        g ? S(() => {
          i();
        }) : (n.value && n.value.style.removeProperty("display"), T());
      }
    ), B(
      () => e.disabled,
      (g) => {
        e.detached && !g && S(() => i());
      }
    ), B(
      () => e.text,
      (g) => {
        e.detached && !g && S(() => i());
      }
    ), B(
      () => e.show,
      (g) => {
        g ? (document.removeEventListener("click", t.value), t.value = function() {
          e.show && (document.removeEventListener("click", t.value), y("body-off"));
        }, setTimeout(() => {
          document.addEventListener("click", t.value);
        }, 100), q()) : _(), S(() => {
          v(g);
        });
      }
    ), V(() => {
      T();
    });
    const l = E(() => {
      const g = [];
      return Object.keys(b).forEach((p) => {
        if (b[p] !== void 0)
          switch (g.push("t-tooltip--" + p), p) {
            case "tc":
              u.value = "t-bc";
              break;
            case "bc":
              u.value = "t-tc";
          }
      }), u.value === "t-bc" && g.push("t-tooltip--tc"), g.toString().replace(/,/g, " ");
    });
    function i() {
      e.disabled || !e.detached || (e.show || _(), document.addEventListener("scroll", z, { capture: !0, passive: !0 }), window.addEventListener("resize", z, { capture: !0, passive: !0 }), v(e.show));
    }
    function T() {
      x.value && q(), document.removeEventListener("scroll", z, { capture: !0 }), window.removeEventListener("resize", z, { capture: !0 });
    }
    function v(g) {
      if (!(!e.detached || e.disabled || !r.value))
        if (g) {
          n.value.style.display = "block";
          const p = a.value.getBoundingClientRect();
          n.value.style.display = "none", r.value.style.top = `${Math.ceil(p.y)}px`, r.value.style.left = `${Math.ceil(p.x)}px`, r.value.style.width = `${Math.ceil(p.width)}px`, r.value.style.height = `${Math.ceil(p.height)}px`, r.value.style.display = "block";
        } else
          r.value.style.display = "none";
    }
    function _() {
      s.value.addEventListener("mouseover", O), s.value.addEventListener("mouseleave", I);
    }
    function q() {
      s.value.removeEventListener("mouseover", O), s.value.removeEventListener("mouseleave", I);
    }
    function O() {
      v(!k.value);
    }
    function I() {
      v(!1);
    }
    function z() {
      k.value = !0, v(!1), clearTimeout(w), w = window.setTimeout(() => {
        var p;
        k.value = !1;
        const g = !!(e.show || (p = s.value) != null && p.matches(":hover"));
        v(g), clearTimeout(w);
      }, 180);
    }
    return x.value = document.querySelector("#detached-tooltips"), x.value || (x.value = document.createElement("div"), x.value.id = "detached-tooltips", document.body.appendChild(x.value)), (g, p) => (d(), m("div", {
      ref_key: "tRoot",
      ref: s,
      class: h(["t-tooltip-wrap", [{ "t-show": e.show }, l.value, { "is-detached": e.detached }]])
    }, [
      C(g.$slots, "default"),
      e.disabled ? D("", !0) : (d(), m("div", {
        key: 0,
        ref_key: "tooltip",
        ref: n,
        class: "tooltip-inner"
      }, [
        e.text ? (d(), m("div", {
          key: 0,
          ref_key: "tContent",
          ref: a,
          class: h(["t-tooltip", u.value]),
          onClick: p[0] || (p[0] = (N) => y("off")),
          innerHTML: e.text
        }, null, 10, re)) : (d(), m("div", {
          key: 1,
          ref_key: "tContent",
          ref: a,
          class: h(["t-tooltip", u.value]),
          onClick: p[1] || (p[1] = (N) => y("off"))
        }, [
          C(g.$slots, "text")
        ], 2))
      ], 512)),
      (d(), G(Q, {
        to: "#detached-tooltips",
        disabled: !e.detached
      }, [
        e.text ? (d(), m("div", {
          key: 0,
          ref_key: "tContentClone",
          ref: r,
          class: h(["t-tooltip", u.value]),
          onClick: p[2] || (p[2] = (N) => y("off")),
          innerHTML: e.text,
          style: j(!e.detached || e.disabled ? "display: none" : "")
        }, null, 14, ue)) : (d(), m("div", {
          key: 1,
          ref_key: "tContentClone",
          ref: r,
          class: h(["t-tooltip", u.value]),
          onClick: p[3] || (p[3] = (N) => y("off")),
          style: j(!e.detached || e.disabled ? "display: none" : "")
        }, [
          C(g.$slots, "text")
        ], 6))
      ], 8, ["disabled"]))
    ], 2));
  }
});
function fe(o, c, e = !0, ...s) {
  let t = 0;
  return function(n) {
    const a = n, r = function() {
      t = 0, e || o.apply(a, s);
    }, u = e && !t;
    window.clearTimeout(t), t = window.setTimeout(r, c), u && o.apply(a, s);
  };
}
const ve = ["disabled", "data-qe-id"], pe = {
  key: 0,
  class: "t-button-pa"
}, me = /* @__PURE__ */ L({
  __name: "TButton",
  props: {
    color: String,
    size: String,
    disabled: {
      type: Boolean,
      default: !1
    },
    inactive: {
      type: Boolean,
      default: !1
    },
    progress: {
      type: Boolean,
      default: !1
    },
    complementary: {
      type: Boolean,
      default: !1
    },
    dataQeId: {
      type: String,
      default: "button"
    }
  },
  emits: ["click"],
  setup(o, { emit: c }) {
    const e = A(), s = o, t = c;
    let n;
    const a = () => {
      const r = [];
      return Object.keys(e).forEach((u) => {
        e[u] !== void 0 && r.push(u);
      }), s.complementary !== !1 && r.push("complementary"), r.join(" ");
    };
    return H(() => {
      n = fe(function() {
        !s.inactive && !s.progress && t("click");
      }, 500);
    }), F(() => {
      n = () => {
      };
    }), (r, u) => (d(), m("button", {
      class: h(["t-button", [a(), o.color, o.size, o.disabled || o.inactive ? "inactive" : "", o.progress ? "inactive progress" : ""]]),
      disabled: o.disabled,
      onClick: u[0] || (u[0] = //@ts-ignore
      (...x) => M(n) && M(n)(...x)),
      "data-qe-id": o.dataQeId
    }, [
      f("span", null, [
        C(r.$slots, "default")
      ]),
      o.progress ? (d(), m("div", pe, u[1] || (u[1] = [
        f("div", { class: "t-button-pa--bounce1" }, null, -1),
        f("div", { class: "t-button-pa--bounce2" }, null, -1),
        f("div", { class: "t-button-pa--bounce3" }, null, -1)
      ]))) : D("", !0)
    ], 10, ve));
  }
}), ge = { class: "t-toggle-box" }, he = ["data-qe-id", "aria-expanded", "aria-controls"], be = ["id"], ye = { class: "body-in-border" }, xe = /* @__PURE__ */ L({
  __name: "TToggleBox",
  props: {
    title: String,
    qeId: String,
    open: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["toggle"],
  setup(o, { emit: c }) {
    const e = o, s = c, t = R(), n = $(!1), a = $(null), r = $(null), u = $(0);
    H(() => {
      var b;
      e.open ? w() : (b = a.value) == null || b.setAttribute("inert", "");
    });
    const x = () => {
      s("toggle", w());
    };
    function k(b) {
      (b.key === "Enter" || b.key === " ") && (b.preventDefault(), s("toggle", w()));
    }
    const w = () => {
      var b, y, l, i, T;
      return n.value ? ((i = a.value) == null || i.setAttribute("style", `max-height: ${u.value + 2}px;`), (T = a.value) == null || T.setAttribute("inert", ""), setTimeout(() => {
        var v;
        n.value = !n.value, (v = a.value) == null || v.setAttribute("style", "max-height: 0;");
      }, 100), !n.value) : (n.value = !n.value, u.value = n.value ? ((b = r.value) == null ? void 0 : b.offsetHeight) ?? 0 : 0, (y = a.value) == null || y.setAttribute("style", `max-height: ${u.value + 2}px;`), (l = a.value) == null || l.removeAttribute("inert"), setTimeout(() => {
        var v;
        (v = a.value) == null || v.setAttribute("style", "max-height: inherit;");
      }, 600), n.value);
    };
    return (b, y) => (d(), m("div", ge, [
      f("header", null, [
        f("h3", {
          class: h(["headline", n.value ? "clicked" : ""]),
          onClick: x,
          "data-qe-id": o.qeId,
          role: "button",
          tabindex: "0",
          "aria-expanded": n.value,
          "aria-controls": M(t),
          onKeydown: y[0] || (y[0] = (l) => k(l))
        }, [
          K(U(o.title) + " ", 1),
          y[1] || (y[1] = f("i", { class: "icf-arrowBottom" }, null, -1))
        ], 42, he)
      ]),
      f("div", {
        ref_key: "body",
        ref: a,
        id: M(t),
        class: h(["body", n.value ? "show" : ""])
      }, [
        f("div", {
          ref_key: "bodyIn",
          ref: r,
          class: "body-in"
        }, [
          f("div", ye, [
            C(b.$slots, "default", {}, void 0, !0)
          ]),
          C(b.$slots, "bottom", {}, void 0, !0)
        ], 512),
        y[2] || (y[2] = f("div", { class: "bottom" }, null, -1))
      ], 10, be)
    ]));
  }
}), ke = /* @__PURE__ */ P(xe, [["__scopeId", "data-v-9de56bff"]]), Te = ["innerHTML"], $e = /* @__PURE__ */ L({
  __name: "TCollapsibleList",
  props: {
    htmlText: String,
    clickTag: {
      type: String,
      required: !0
    }
  },
  emits: ["action"],
  setup(o, { emit: c }) {
    const e = o, s = R(), t = $(null), n = c, a = () => {
      const l = t.value;
      S(() => {
        let i;
        Array.from(t.value.children).forEach((T) => {
          var v;
          T.tagName === ((v = e.clickTag) == null ? void 0 : v.toUpperCase()) ? (l.appendChild(T), i = void 0, i = document.createElement("div"), i.className = "collapsible-content", l.appendChild(i)) : i == null || i.appendChild(T);
        });
      }), S(() => {
        const i = t.value.querySelectorAll(e.clickTag), T = t.value.querySelectorAll(".collapsible-content");
        let v = 0;
        Array.from(i).forEach((_) => {
          _.setAttribute("data-qe-id", `faq-headline-${++v}`), r(_), u(_), x(_, `${s}-${v}`);
        }), v = 0, Array.from(T).forEach((_) => {
          _.setAttribute("data-qe-id", `faq-content-${++v}`), _.addEventListener("click", (q) => {
            n("action", q);
          }), _.setAttribute("id", `${s}-${v}`), _.setAttribute("inert", "");
        });
      });
    }, r = (l) => {
      l.classList.add("headline");
      const i = document.createElement("i");
      i.classList.add("icf-arrowBottom"), l.appendChild(i);
    }, u = (l) => {
      l.addEventListener("click", w), l.addEventListener("keydown", k);
    };
    function x(l, i) {
      l.setAttribute("role", "button"), l.setAttribute("tabindex", "0"), l.setAttribute("aria-expanded", "false"), l.setAttribute("aria-controls", i);
    }
    function k(l) {
      (l.key === "Enter" || l.key === " ") && (w(l), l.preventDefault());
    }
    function w(l) {
      const i = l.target;
      i.classList.contains("open") ? y(i) : b(i);
    }
    function b(l) {
      var i;
      l.classList.add("open"), l.setAttribute("aria-expanded", "true"), (i = l.nextSibling) == null || i.removeAttribute("inert");
    }
    function y(l) {
      var i;
      l.classList.remove("open"), l.setAttribute("aria-expanded", "false"), (i = l.nextSibling) == null || i.setAttribute("inert", "");
    }
    return H(a), B(() => e.htmlText, a), (l, i) => {
      const T = J("t-text");
      return d(), G(T, null, {
        default: W(() => [
          f("div", {
            class: "t-collapsible-list",
            ref_key: "textNode",
            ref: t,
            innerHTML: o.htmlText
          }, null, 8, Te)
        ]),
        _: 1
      });
    };
  }
}), _e = {
  key: 1,
  class: "t-progress--horizontal"
}, Ce = /* @__PURE__ */ L({
  __name: "TProgress",
  props: {
    horizontal: {
      type: Boolean,
      default: !1
      // activate horizontal version
    },
    absolute: {
      type: Boolean,
      default: !1
    },
    fixed: {
      type: Boolean,
      default: !1
    },
    // configure t-shirt sizes s, m, l
    size: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    }
  },
  setup(o) {
    const c = A(), e = o, s = E(() => {
      const t = [];
      return Object.keys(c).forEach((n) => {
        c[n] !== void 0 && t.push("t-progress--" + n);
      }), e.size && t.push("t-progress--" + e.size), e.color && t.push("t-progress--" + e.color), e.absolute !== !1 && t.push("t-progress--absolute"), e.fixed !== !1 && t.push("t-progress--fixed"), t.join(" ");
    });
    return (t, n) => (d(), m("div", {
      class: h(["t-progress", `${s.value}`]),
      "data-qe-id": "progress"
    }, [
      o.horizontal === !1 ? (d(), m("div", {
        key: 0,
        class: h(["circle", o.size])
      }, null, 2)) : (d(), m("div", _e, n[0] || (n[0] = [
        f("div", { class: "t-progress--horizontal--bounce1" }, null, -1),
        f("div", { class: "t-progress--horizontal--bounce2" }, null, -1),
        f("div", { class: "t-progress--horizontal--bounce3" }, null, -1)
      ])))
    ], 2));
  }
}), we = ["data-gametype", "data-qe-id"], Le = /* @__PURE__ */ L({
  __name: "TGameLogo",
  props: {
    size: String,
    gametype: String
  },
  setup(o) {
    const c = A(), e = o, s = E(() => {
      const t = [];
      return e.size ? t.push(e.size === "s" ? "gameLogo60x40" : "gamelogo106x74") : Object.keys(c).forEach((n) => {
        c[n] !== void 0 && (n === "s" ? t.push("gameLogo60x40") : n === "m" && t.push("gamelogo106x74"));
      }), t.indexOf("gameLogo60x40") === -1 && t.indexOf("gamelogo106x74") === -1 && t.push("gamelogo106x74"), t.push("game_" + e.gametype), process.env.NODE_ENV === "development" && t.push("t-game-logo--dev"), t;
    });
    return (t, n) => (d(), m("div", {
      onClick: n[0] || (n[0] = (a) => t.$emit("click", a)),
      class: h(s.value),
      "data-gametype": o.gametype,
      "data-qe-id": `game-logo-${o.gametype}`
    }, null, 10, we));
  }
}), Ee = {
  class: "t-pagination",
  "data-qe-id": "pagination"
}, Ae = ["onClick", "data-qe-id"], Se = /* @__PURE__ */ L({
  __name: "TPagination",
  props: {
    items: { type: Number, default: 0 },
    chunk: { type: Number, default: 0 },
    activePage: { type: Number, default: 0 }
  },
  emits: ["click"],
  setup(o, { emit: c }) {
    const e = o, s = c, t = E(() => Array.from({ length: Math.ceil(e.items / e.chunk) }, (u, x) => ({
      idx: x
    }))), n = () => {
      e.activePage <= 0 || s("click", e.activePage - 1);
    }, a = (u) => {
      s("click", u);
    }, r = () => {
      e.activePage >= t.value.length - 1 || s("click", e.activePage + 1);
    };
    return (u, x) => (d(), m("div", Ee, [
      f("div", {
        class: h([o.activePage <= 0 ? "t-pagination-inactive" : "", "t-pagination-btn icf-arrowLeft"]),
        onClick: n,
        "data-qe-id": "prev"
      }, null, 2),
      f("ul", null, [
        (d(!0), m(X, null, Y(t.value, (k) => (d(), m("li", {
          key: k.idx
        }, [
          f("div", {
            onClick: (w) => a(k.idx),
            class: h(["button", k.idx === o.activePage ? "t-pagination-active" : ""]),
            "data-qe-id": `num-${k.idx}`
          }, [
            f("span", null, U(k.idx + 1), 1)
          ], 10, Ae)
        ]))), 128))
      ]),
      f("div", {
        class: h([o.activePage >= t.value.length - 1 ? "t-pagination-inactive" : "", "t-pagination-btn icf-arrowRight"]),
        onClick: r,
        "data-qe-id": "next"
      }, null, 2)
    ]));
  }
}), Be = /* @__PURE__ */ P(Se, [["__scopeId", "data-v-397939f1"]]);
function ze(o) {
  o.component("t-container", oe), o.component("t-text", ne), o.component("t-header", le), o.component("t-card", ie), o.component("t-content", ce), o.component("t-tooltip", de), o.component("t-button", me), o.component("t-toggle-box", ke), o.component("t-collapsible-list", $e), o.component("t-progress", Ce), o.component("t-game-logo", Le), o.component("t-pagination", Be);
}
export {
  me as TButton,
  ie as TCard,
  $e as TCollapsibleList,
  oe as TContainer,
  ce as TContent,
  Le as TGameLogo,
  le as THeader,
  Be as TPagination,
  Ce as TProgress,
  ne as TText,
  ke as TToggleBox,
  de as TTooltip,
  ze as default,
  ze as loadTComponents
};
